import request from '@/utils/request'
import { USER_INFO_PREFIX } from '@/utils/cacheUtil'
/**
 * 用户列表
 */
export function listUser(query) {
  return request({
    url: '/user/getAll',
    method: 'get',
    params: query
  })
}

/**
 * 新增用户
 * @returns 
 */
export function addUser(data) {
  return request({
    url: '/user/add',
    method: 'post',
    data: data
  })
}

/**
 * 用户登录
 * @returns 
 */
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data
  })
}
/**
 * 获取登录用户信息
 */
export async function getLoginUserInfo() {
  //返回用户信息
  let resUserInfo = await request({ url: '/getUserInfo', method: 'get' })
  return resUserInfo.data
  /* .then(res => {
    tore.dispatch('updateUseInfo', res.data)
    sessionStorage.setItem(USER_INFO_PREFIX, JSON.stringify(res.data))
  }) */

}

/**
 * 登录短信发送
 */
export const loginCodeSending = (data) => request({url:'/m/sms/code',method:'get', params: data})

/**
 * 更新登录企业
 */
export const updateLoginCompany = (id) => request({url:'/m/updateLoginCompany',method:'get',params:{id: id}}) 

/**
 * 获取当前用户相关部门信息
 */
export const listCurrentUserDept = ()=> request({url:'/department/listCurrentUserDept',method:'get'})
